import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function GTMTracker({ language }) {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
      page: location.pathname,
      title: document.title,
      language: language
    });
  }, [location, language]);

  return null;
}